import { render, staticRenderFns } from "./MandateFail.vue?vue&type=template&id=23823026&scoped=true"
import script from "./MandateFail.vue?vue&type=script&lang=ts"
export * from "./MandateFail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23823026",
  null
  
)

export default component.exports